import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import config from "../../../config";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import {
  Col,
  Container,
  CustomContainer,
  DropdownButton,
  Row,
} from "../../atoms/DependencyHelper";
import labels from "../../../config/labels";
import * as Analytics from "../../../services/analyticsUtag";
import styles from "./UpgradePageFilters.module.scss";

const UpgradePageFilters = (props) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const imgUrl = `${imagePrefix}/assets/images/warning-black.svg`;
  const [selectedBrands, setSelectedBrands] = useState();
  const [localModel, setLocalModel] = useState();
  const [localContract, setLocalContract] = useState();
  const [contract, setContract] = useState(props?.selectedContractType);
  const [sortedBrands, setSortedBrands] = useState();

  const handleApply = (item) => {
    if (item === "brands") {
      props.setSelectedBrand(selectedBrands);
      setLocalModel();
      props.setSelectedModel();
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: upgrade: recommended deals:brand filter",
        filter_query: selectedBrands,
      });
    } else if (item === "model") {
      props.setSelectedModel(localModel);
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: upgrade: recommended deals:model filter",
        filter_query: localModel,
      });
    } else {
      props.setSelectedContractType(localContract);
      if (localContract===labels.upgrade.planData.lbl_contract_sim_only) {
        props.setSelectedBrand();
        props.setSelectedModel();
        setLocalModel();
        setSelectedBrands();
      }
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: upgrade: recommended deals:deals filter",
        filter_query: localContract,
      });
    }
    document.dispatchEvent(new MouseEvent('click'));
  };

  const handleClear = (item) => {
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: `shopping: upgrade: recommended deals:remove ${
        item === "contract " ? "deals" : item
      } filter`,
    });
    switch (item) {
      case "brands":
        props.setSelectedBrand();
        setSelectedBrands();
        break;
      case "model":
        setLocalModel();
        props.setSelectedModel();
        break;
      default:
        setLocalModel();
        props.setSelectedModel();
        setSelectedBrands();
        props.setSelectedBrand();
        setLocalContract();
        setContract();
        props.setSelectedContractType();
    }
    document.dispatchEvent(new MouseEvent('click'));
  };

  const handleContract = (item) => {
    setContract(item);
    if (item===labels.upgrade.planData.lbl_contract_sim_only) {
      setSelectedBrands();
    }
    setLocalContract(item);
  };

  const handleDisable =()=> {
    return !(props.selectedBrand || props.selectedModel || props.selectedContractType);
  }

  const handleSearchDeals = () => {
    //Magento API to be called
    props.searchDeals();
    Analytics.link({
      link_type: "o",
      link_name: "shopping: upgrade: recommended deals: search deals",
    });
  };

  const truncateString = (str, stringLen) => {
    return str.length > stringLen ? str.substring(0, stringLen) + "..." : str;
  }

  useEffect(() => {
    if (!props.brands) {
      Analytics.link({
        page_name: "shopping: upgrade: recommended deals",
        page_form_event: "error",
        page_errors:
          "We seem to be having some issues loading filters  right now. Please try again later.",
        page_error_type: "page",
      });
    } else {
      setSortedBrands(props?.brands?.sort((a, b) => a.localeCompare(b)));
    }
  }, [props.brands]);

  return (
    <CustomContainer>
      <h2 className={styles["just-heading"]}>Just4You deals</h2>
      {props.brands && props.brands.length > 0 ? (
        <Row>
          <Col md={10} lg={10} className={`px-0 ${styles["left-filters"]}`}>
          <Row className="mx-0">
          <Col md={4} lg={4} className={`pr-ss ${styles["dropdown-container"]}`}>
            <CustomContainer className={styles["contract-heading"]}>
              {labels.upgrade.planData.lbl_looking_for}
            </CustomContainer>
            <DropdownButton
              title={contract ? contract : "-Select-"}
              className={styles["drop-down"]}
              bsPrefix={styles["upgrade-drop-down"]}
            >
              <CustomContainer>
                <CustomContainer className={styles["model-heading"]}>
                  {"Which kind of contract would you like?"}
                </CustomContainer>
                <CustomContainer className={styles["model-options"]}>
                  {props.planData &&
                  props.planData.map((item, index) => (
                    <CustomContainer
                      key={`planData_${index}`}
                      className={`${styles["options"]} ${
                        localContract == item && styles["active-option"]
                      }`}
                    >
                      {/* <CTAButton
                        variant="solid white"
                        handleClick={() => handleContractType(item)}
                      > */}
                      <label
                        htmlFor={item}
                        onClick={() => handleContract(item)}
                      >
                        <input
                          type="radio"
                          value={item}
                          name="contract"
                          id={item}
                          checked= {contract === item}
                        />
                        <span className={styles["option-text"]}>
                              {item}
                            </span>
                      </label>
                      {/* </CTAButton> */}
                    </CustomContainer>
                  ))}
                </CustomContainer>

                <CustomContainer className={styles["modal-apply"]}>
                  <CTAButton
                    variant="outline grey"
                    className={`${styles["clear-btn"]} ${!contract && styles["disabled-clear"]}`}
                    handleClick={() => handleClear("contract")}
                  >
                    {"Reset"}
                  </CTAButton>
                  <CTAButton
                    variant="solid grey"
                    className={`${styles["clear-btn"]} ${!contract && styles["disabled-modal"]}  ${styles["white"]}`}
                    handleClick={() => handleApply("contract")}
                  >
                    {"Apply"}
                  </CTAButton>
                </CustomContainer>
              </CustomContainer>
            </DropdownButton>
          </Col>
          <Col md={4} lg={4} className={`pl-ss pr-ss ${props.selectedContractType === labels.upgrade.planData.lbl_contract_sim_only || !contract ? styles["disabled"] :""} ${styles["dropdown-container"]}`}>
            <CustomContainer className={styles["contract-heading"]}>
              {"Brand"}
            </CustomContainer>

            <DropdownButton
              title={props.selectedBrand ? props.selectedBrand : "-Select-"}
              bsPrefix={`${styles["upgrade-drop-down"]} ${!props.selectedBrand ? styles["dropdown-text"]: ""}`}
            >
              <CustomContainer className={styles["brands-modal"]}>
                <CustomContainer className={styles["model-heading"]}>
                  {"Which brand do you prefer?"}
                </CustomContainer>
                <CustomContainer className={styles["model-options"]}>
                  <Row className={`${styles["brand-container"]}`}>
                    {props.brands && sortedBrands &&
                    sortedBrands.map((item, index) => (
                      <Col
                        key={`brandData_${index}`}
                        md={3}
                        lg={3}
                        className={`${styles["options"]} ${
                          selectedBrands == item && styles["active-option"]
                        }`}
                      >
                        <label
                          htmlFor={item}
                          onClick={() => setSelectedBrands(item)}
                          className={styles["brand-label"]}
                        >
                          <input
                            type="radio"
                            value={item}
                            name="brand"
                            id={item}
                            checked={selectedBrands==item}
                            className={styles["brand-radio"]}
                          />
                          <span className={styles["option-text"]}>
                                {item}
                              </span>
                        </label>
                      </Col>
                    ))}
                  </Row>
                </CustomContainer>
                <CustomContainer className={styles["modal-apply"]}>
                  <CTAButton
                    variant="outline grey"
                    className={`${styles["clear-btn"]} ${!selectedBrands && styles["disabled-clear"]}`}
                    handleClick={() => handleClear("brands")}
                  >
                    {"Clear"}
                  </CTAButton>
                  <CTAButton
                    variant="solid grey"
                    className={`${styles["clear-btn"]} ${!selectedBrands? styles["disabled-modal"]:"" }  ${styles["white"]}`}
                    handleClick={() => handleApply("brands")}
                  >
                    {"Apply"}
                  </CTAButton>
                </CustomContainer>
              </CustomContainer>
            </DropdownButton>
          </Col>
          <Col
            md={4}
            lg={4}
            className={` pl-ss pr-ss ${
              props.selectedBrand ? styles["model"] : styles["disabled"]
            } ${styles["dropdown-container"]}`}
          >
            <CustomContainer className={styles["contract-heading"]}>
              {"Model"}
            </CustomContainer>

            <DropdownButton
              title={props.selectedModel ? props.selectedModel : "-Select-"}
              bsPrefix={`${styles["upgrade-drop-down"]}  ${!props.selectedModel ? styles["dropdown-text"]: ""}`}
            >
              <CustomContainer className={props.models.length >=60 ? styles["brands-modal-large-list"] : styles["brands-modal"]}>
                <CustomContainer
                  className={styles["model-heading"]}
                >{`Which ${props.selectedBrand} model are you looking for?`}</CustomContainer>
                <CustomContainer className={styles["model-options"]}>
                  <Row>
                    {props.models &&
                    props.models.map((item, index) => (
                      <Col
                        key={`modelData_${index}`}
                        md={6}
                        lg={6}
                        className={`${styles["options"]} ${
                          localModel == item && styles["active-option"]
                        }`}
                      >
                        <label
                          htmlFor={item}
                          onClick={() => setLocalModel(item)}
                        >
                          <input
                            type="radio"
                            value={item}
                            name="model"
                            id={item}
                            checked={localModel==item}
                          />
                          <span className={styles["option-text"]}>
                            {props.models.length >=60 ? truncateString(item,55) : truncateString(item,25)}
                              </span>
                        </label>
                      </Col>
                    ))}
                  </Row>
                </CustomContainer>
                <CustomContainer className={styles["modal-apply"]}>
                  <CTAButton
                    variant="outline grey"
                    className={`${styles["clear-btn"]} ${!localModel && styles["disabled-clear"]}`}
                    handleClick={() => handleClear("model")}
                  >
                    {"Clear"}
                  </CTAButton>
                  <CTAButton
                    variant="solid grey"
                    className={`${styles["clear-btn"] } ${!localModel && styles["disabled-modal"]} ${styles["white"]}`}
                    handleClick={() => handleApply("model")}
                  >
                    {"Apply"}
                  </CTAButton>
                </CustomContainer>
              </CustomContainer>
            </DropdownButton>
          </Col>

          </Row>

          </Col>
          <Col md={2} lg={2} className={`pl-ss ${styles["right-filter"]}`}>
            <CustomContainer
              className={`${styles["contract-heading"]} ${styles["hide-btn"]}  `}
            >
              {"show-deal"}
            </CustomContainer>
            <CTAButton variant="solid grey" handleClick={handleSearchDeals} disabled ={handleDisable()} className={`${styles["deals-btn"]} ${handleDisable()? styles["disabled"]:""}`}>
              {"Search deals"}
            </CTAButton>
          </Col>
        </Row>
      ) : (
        <CustomContainer className={styles["error-message"]}>
          <img src={imgUrl} width={18} height={18} className={styles["error-message-icon"]}/>
          <span>
              We seem to be having some issues loading filters right now. Please
              try again later.
            </span>
        </CustomContainer>
      )}
    </CustomContainer>
  );
};

UpgradePageFilters.propTypes = {
  planData: PropTypes.array,
  brands: PropTypes.array,
  models: PropTypes.array,
  selectedContractType: PropTypes.string
}

export default UpgradePageFilters;
